export interface IVendorRecord {
  id: number;
  setId: string;
  vendorId: string;
  persistence: string;
  shortVendorName: string;
  ourCustomerNumber: string;
  name: string;
  [key: string]: unknown;
}

export const vendors: IVendorRecord[] = [
  {
    id: 1,
    setId: "EMR021",
    vendorId: "MED-21045",
    persistence: "Active",
    shortVendorName: "CARE360",
    ourCustomerNumber: "CUST-55101",
    name: "Care360 Electronic Health Records",
  },
  {
    id: 2,
    setId: "EMR022",
    vendorId: "MED-21478",
    persistence: "Active",
    shortVendorName: "CAREMED",
    ourCustomerNumber: "CUST-55102",
    name: "CareMed Clinical Systems LLC",
  },
  {
    id: 3,
    setId: "EMR023",
    vendorId: "MED-21903",
    persistence: "Pending",
    shortVendorName: "CAREPT",
    ourCustomerNumber: "CUST-55103",
    name: "CarePoint EMR Technologies",
  },
  {
    id: 4,
    setId: "EMR024",
    vendorId: "MED-22367",
    persistence: "Active",
    shortVendorName: "CAREONE",
    ourCustomerNumber: "CUST-55104",
    name: "CareOne Patient Management Solutions",
  },
  {
    id: 5,
    setId: "EMR025",
    vendorId: "MED-22814",
    persistence: "Inactive",
    shortVendorName: "TRUECAR",
    ourCustomerNumber: "CUST-55105",
    name: "TrueCare Digital Healthcare Systems",
  },
];

export interface VendorSearchCriteria {
  vendorName?: string | null;
  vendorId?: string | null;
}

const normalize = (s?: string | null) => (s ?? "").trim().toLowerCase();

export const searchVendors = (
  criteria: VendorSearchCriteria,
): Promise<IVendorRecord[]> =>
  new Promise((resolve) => {
    // simulated API latency
    setTimeout(() => {
      const name = normalize(criteria.vendorName);
      const vendorId = normalize(criteria.vendorId);

      resolve(
        vendors.filter((v) => {
          if (
            name &&
            !v.name.toLowerCase().includes(name) &&
            !v.shortVendorName.toLowerCase().includes(name)
          )
            return false;
          if (vendorId && !v.vendorId.toLowerCase().includes(vendorId))
            return false;
          return true;
        }),
      );
    }, 400);
  });
